import React from 'react';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import PrematchContext from '../../contexts/PrematchContext';
import { filtraParametriche } from '../../data/utils';
import { getLabel } from '../../data/labels';
import PrematchTournamentMatch from '../prematch-home/PrematchTournamentMatch';

export default function Events(props) {
    const prematchContext = React.useContext(PrematchContext);
    let fiveColumnTemplate = true;
    const items = props.items;

    function openEvent(event) {
        const tournamentUniqueId = `${event.sportRef}_${event.categoryRef}_${event.tournamentRef}`;
        prematchContext.openEvent(tournamentUniqueId, event);
    }

    return (
        <div className="partite-del-giorno tab-pane fade show active overflow-visible" role="tabpanel">
            <div className="contenitore-table-grande">
                <span>{props.title}</span>
                {items.map(events => {
                    const firstEvent = events[0];
                    return <div key={(props.extra? 'extra':'cota')} className="contenitore-table bg-bianco bordo-tondo">
                            <div className={"tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch tabellaQuoteIntestazionePrematch_template-2 mb-2 "+ (fiveColumnTemplate ? 'tabellaQuotePrematch_5col' : '')} >
                                <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                    <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                </div>
                                <div className="tabellaQuoteSquadre"></div>
                                <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                    <BetsOddsHeader bets={filtraParametriche(firstEvent.gruppiScommessa[0].scommesse)} matches={firstEvent.events} />
                                </div>
                                <div className="tabellaQuoteStatistiche"></div>
                                {!fiveColumnTemplate &&
                                    <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                                }
                                <div className="tabellaQuoteTorneo d-flex align-items-center pl-1">{props.title} - {firstEvent.sportDesc} </div>
                            </div>
                            {events.map(event =>
                                <PrematchTournamentMatch key={event.pal + "_" + event.avv + "_" + (props.extra? 'extra':'cota')} match={event} aggregata={event.openAggregata} isLive={false} openMatch={openEvent} showTournamentDesc={true} />
                            )}
                   </div>
                
                })}
            </div>
        </div>
    );
}
